import { render, staticRenderFns } from "./SectionMenu.vue?vue&type=template&id=4f00f40c&scoped=true&lang=pug&"
import script from "./SectionMenu.vue?vue&type=script&lang=js&"
export * from "./SectionMenu.vue?vue&type=script&lang=js&"
import style0 from "./SectionMenu.vue?vue&type=style&index=0&id=4f00f40c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f00f40c",
  null
  
)

export default component.exports